import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalSmsPage } from './modal-sms.page';

const routes: Routes = [
  {
    path: '',
    component: ModalSmsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalSmsPageRoutingModule {}
